import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "popup-main" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = {
  key: 0,
  class: "popup-title"
}
const _hoisted_4 = { class: "popup-content" }


export default {
  __name: 'PopupForm',
  props: ['title', 'displayType'],
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", {
    ref: "selfRef",
    class: _normalizeClass(`form-popup ${__props.displayType}`)
  }, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (__props.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1))
              : _createCommentVNode("", true),
            (__props.displayType == 'style1')
              ? _withDirectives((_openBlock(), _createBlock(_component_van_icon, {
                  key: 1,
                  class: "close-icon",
                  name: "cross",
                  onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
                }, null, 512)), [
                  [_directive_audio, void 0, "close"]
                ])
              : (__props.displayType == 'style2' || __props.displayType == 'style4')
                ? _withDirectives((_openBlock(), _createBlock(_component_van_icon, {
                    key: 2,
                    class: "close-icon",
                    name: "clear",
                    onClick: _cache[1] || (_cache[1] = $event => (emit('onClose')))
                  }, null, 512)), [
                    [_directive_audio, void 0, "close"]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_van_icon, {
                    key: 3,
                    class: "close-icon",
                    name: "close",
                    onClick: _cache[2] || (_cache[2] = $event => (emit('onClose')))
                  }, null, 512)), [
                    [_directive_audio, void 0, "close"]
                  ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

}